import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { UserState } from '@/store/user/user.state';
import { Observable, of } from 'rxjs';
import { UserDetailDto } from '@artemis-software/wr-api';
import { DatePipe } from '@angular/common';

@Component({
  standalone: false,
  selector: 'wr-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent {
  @Input()
  formGroup!: FormGroup;

  @Select(UserState.currentUser)
  currentUser$!: Observable<UserDetailDto | undefined>;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly datePipe: DatePipe,
  ) {}

  get comments(): FormArray {
    return this.formGroup.controls['comments'] as FormArray;
  }

  addComment(): void {
    this.comments.push(this.formBuilder.group({
      id: new FormControl(null),
      text: new FormControl(''),
      isChecked: new FormControl(false),
      createdBy: new FormControl(null),
      checkedBy: new FormControl(null),
      created: new FormControl(null),
      lastUpdated: new FormControl(null),
    }));
  }

  removeComment(index: number): void {
    this.comments.removeAt(index);
  }

  check(index: number): void {
    this.comments.at(index).get('isChecked')?.setValue(true);
  }

  uncheck(index: number): void {
    this.comments.at(index).get('isChecked')?.setValue(false);
  }

  isChecked(index: number): boolean {
    return this.comments.at(index).get('isChecked')?.value;
  }

  getCreatedBy(index: number): Observable<UserDetailDto | undefined> {
    const user = this.comments.at(index).get('createdBy')?.value;
    return user ? of(user) : this.currentUser$;
  }

  getCreated(index: number): string | null {
    const value = this.comments.at(index).get('created')?.value;
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : this.datePipe.transform(date, 'dd.MM.yyyy HH:mm');
  }

  isEdited(index: number): boolean {
    return this.comments.at(index).get('created')?.value !== this.comments.at(index).get('lastUpdated')?.value;
  }

  checkedBy(index: number): UserDetailDto | undefined {
    return this.comments.at(index).get('checkedBy')?.value;
  }

  canEdit(createdBy: UserDetailDto | null, currentUser: UserDetailDto | undefined | null): boolean {
    return createdBy?.id === currentUser?.id || createdBy === null;
  }

  getUserProfile(user: UserDetailDto): string {
    const fallback = 'https://i.imgur.com/ujW6tKI.png';
    return user.userProfilePicture?.presignedUrl ?? fallback;
  }
}
